export const locales = [
  "en",
  "es",
  "de",
  "it",
  "fr",
  "nl",
  "da",
  "sv",
  "no",
  "fi",
  "ru",
  "tr",
  "ar",
  "ja",
  "ko",
  "zh",
] as const;

export type Locale = (typeof locales)[number];
